import { useEffect, useRef, useState } from "react";
import "./Preloader.css";
import logo from "../../assets/logo-removebg.png"; // ✅ use your logo here

export default function Preloader({ minDuration = 600 }) {
  const [mounted, setMounted] = useState(false);
  const [hiding, setHiding] = useState(false);
  const [gone, setGone] = useState(false);
  const startRef = useRef(Date.now());

  useEffect(() => {
    setMounted(true);

    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const finish = () => {
      const elapsed = Date.now() - startRef.current;
      const wait = Math.max(0, minDuration - elapsed);

      window.setTimeout(() => {
        setHiding(true);
        window.setTimeout(() => {
          setGone(true);
          document.body.style.overflow = prev;
        }, 280);
      }, wait);
    };

    if (document.readyState === "complete") {
      finish();
      return () => (document.body.style.overflow = prev);
    }

    window.addEventListener("load", finish, { once: true });
    return () => {
      window.removeEventListener("load", finish);
      document.body.style.overflow = prev;
    };
  }, [minDuration]);

  if (gone) return null;

  return (
    <div className={`preMini ${mounted ? "is-mounted" : ""} ${hiding ? "is-hiding" : ""}`}>
      <div className="preMini__mark" aria-hidden="true">
        <span className="preMini__ring" />
        <img className="preMini__logo" src={logo} alt="NesflixDigital" />
      </div>

      <div className="preMini__dots" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}
